import CryptoJS from "crypto-js";

/**
 * Tạo chữ ký HMAC cho request
 */
export function createHmacSignature({
    method,
    url,
    timestamp,
    body,
    secret,
}) {
    const normalizedBody =
        method.toUpperCase() === "GET" || method.toUpperCase() === "DELETE"
            ? ""
            : body
                ? JSON.stringify(body)
                : "";

    const payload = [
        method.toUpperCase(),
        url,
        timestamp,
        normalizedBody,
    ].join("|");

    // console.log("🔐 CLIENT PAYLOAD:", payload);

    return CryptoJS.HmacSHA256(payload, secret).toString(
        CryptoJS.enc.Hex
    );
}

export function createHmacSignatureStreamVideo({
    method,
    fileId,
    timestamp,
    secret,
}) {


    const payload = [
        method.toUpperCase(),
        fileId,
        timestamp,
    ].join("|");

    // console.log("🔐 CLIENT PAYLOAD:", payload);

    return CryptoJS.HmacSHA256(payload, secret).toString(
        CryptoJS.enc.Hex
    );
}